'use client';

import { useIntl } from 'react-intl';
import { usePriceFormatter } from '@packages/shared/src/hooks/usePriceFormatter/usePriceFormatter';
import type { MessageValue } from 'react-intl';
import { OutlinedCard } from '../../../../OutlinedCard/OutlinedCard';
import { CallToActionButton } from '../../atoms/CallToActionButton/CallToActionButton.client';
import { TipBadge } from '../../atoms/TipBadge/TipBadge.client';

export type OutlinedWithTipBadgeProps = {
  /**
   * the single installment value from the calculation result as float (e.g. 13.37)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * open dialog handler
   */
  openInstallmentCalculatorHandler: () => void;
};

/**
 * Installment Calculator call to action component in minimal design
 *
 * component to promote the installment calculator in a minimal layout version
 *
 * */

export const OutlinedWithTipBadge = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  openInstallmentCalculatorHandler,
}: OutlinedWithTipBadgeProps) => {
  const { formatMessage } = useIntl();
  const formatPrice = usePriceFormatter('INSTALLMENTCALCULATOR');

  return (
    <OutlinedCard className="relative">
      <div className="flex flex-row flex-nowrap items-center gap-1.5">
        <TipBadge />
        <div>
          <div className="text-size-body-base font-bold">
            {formatMessage<{
              readonly installments: number | bigint;
              readonly value: MessageValue;
            }>(
              {
                id: 'ic.promotion.OutlinedWithBadge.text',
                defaultMessage:
                  'Oder ab {value} mtl. in {installments, plural, one {# Rate} other {# Raten}}',
              },
              {
                value: formatPrice(singleInstallment, currency),
                installments: numberOfInstallments,
              },
            )}
          </div>
          <CallToActionButton
            className="text-left"
            openInstallmentCalculatorHandler={openInstallmentCalculatorHandler}
          />
        </div>
      </div>
    </OutlinedCard>
  );
};
